// The eleven agents grouped by lifecycle stage, as on the US /ai/ page. One
// source for "The lineup" and "What we automate", so the two always agree.
// `key` is the stage label in the dictionary (ai.lineup.stages) and the slugs
// are the keys of ai.live_in_production.tasks.
export const STAGES = [
  {
    id: 'plan',
    key: 'plan',
    slugs: ['purchase_order_follow_up', 'tender_failures'],
  },
  {
    id: 'execute',
    key: 'execute',
    slugs: [
      'tracking_and_status_updates',
      'proactive_load_audits',
      'scheduling_and_re_scheduling',
    ],
  },
  {
    id: 'gate-yard-dock',
    key: 'gate_yard_dock',
    slugs: [
      'dock_schedule_management',
      'yard_task_orchestration',
      'warehouse_customer_service',
      'detention_handling',
    ],
  },
  {
    id: 'settle',
    key: 'settle',
    slugs: ['document_collection_and_filing', 'claims_processing'],
  },
];
